import { Box, Typography } from '@mui/material';
import { Assignment } from '@mui/icons-material';

interface EmptyStateProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
}

const EmptyState = ({ 
  title, 
  subtitle = "Intenta refrescar la página o verifica tu conexión", 
  icon 
}: EmptyStateProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        padding: 4,
        textAlign: 'center',
        backgroundColor: '#FAFAFA',
        borderRadius: '8px',
        border: '1px solid #E6E6E6',
        margin: 2
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          backgroundColor: '#F4F4F4',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 3
        }}
      >
        {icon || (
          <Assignment
            sx={{
              fontSize: 32,
              color: '#9E9E9E'
            }}
          />
        )}
      </Box>
      
      <Typography
        variant="h6"
        sx={{
          fontWeight: 500,
          fontSize: '16px',
          lineHeight: '24px',
          color: '#424242',
          marginBottom: 1,
          fontFamily: '"Open Sans", sans-serif'
        }}
      >
        {title}
      </Typography>
      
      <Typography
        variant="body2"
        sx={{
          fontSize: '14px',
          lineHeight: '20px',
          color: '#757575',
          maxWidth: '400px',
          fontFamily: '"Open Sans", sans-serif'
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default EmptyState; 